import { useMutation, useQueryClient } from '@tanstack/react-query';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { InsuranceFormData } from '@/features/dashboard/insurances/schemas/insuranceSchema.ts';
import { insuranceMapper } from '@/features/dashboard/insurances/types/InsuranceWebDto.mapper.ts';
import { toast } from 'sonner';

export default function useCreateInsurance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InsuranceFormData) =>
      insurancesApi.create(insuranceMapper.fromFormToDto(data)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insurancesApiQueryKeys.all(),
      });
      toast.success('Ubezpieczenie zostało utworzone');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas tworzenia ubezpieczenia.',
      });
    },
  });
}
